'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".BackButton-module_backButtonWrapper__ovASM{background:transparent;border:0;cursor:pointer;height:40px;position:relative;width:40px}.BackButton-module_bar__LfVYZ{background:#000;border-radius:2px;height:2px;left:14px;position:absolute;top:15px;transform:rotate(-45deg);width:10px}.BackButton-module_barReverse__MRt1b{top:21px;transform:rotate(45deg)}";
var styles = {"backButtonWrapper":"BackButton-module_backButtonWrapper__ovASM","bar":"BackButton-module_bar__LfVYZ","barReverse":"BackButton-module_barReverse__MRt1b BackButton-module_bar__LfVYZ"};
styleInject["default"](css_248z, '696c7d53-396e-4d2f-b317-2c1508819654');

exports["default"] = styles;
